import React from "react";

function NotAuthorised() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-slate-950 text-slate-100">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-cyan-400/20 blur-3xl" />
        <div className="absolute -right-20 top-1/3 h-80 w-80 rounded-full bg-rose-400/20 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-64 w-64 rounded-full bg-amber-300/15 blur-3xl" />
      </div>

      <section className="relative mx-auto flex min-h-screen max-w-5xl items-center px-6 py-12 sm:px-8 lg:px-12">
        <div className="w-full rounded-3xl border border-white/15 bg-white/10 p-6 shadow-2xl backdrop-blur-xl sm:p-10">
          <div className="mb-8 flex items-center gap-4">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-500/20 ring-1 ring-rose-300/30">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.7"
                className="h-8 w-8 text-rose-200"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M6.938 4h10.124c.98 0 1.57 1.08 1.042 1.9l-5.062 7.875a1.25 1.25 0 0 1-2.084 0L5.896 5.9C5.368 5.08 5.958 4 6.938 4Z" />
              </svg>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-rose-200/80">Access Restricted</p>
              <h1 className="mt-1 text-2xl font-bold leading-tight text-white sm:text-3xl">
                Error: You are not authorised to access this page.
              </h1>
            </div>
          </div>

          <p className="max-w-2xl text-sm leading-relaxed text-slate-200 sm:text-base">
            Your account does not have permission for this section. If you believe this is a mistake,
            contact your administrator and request access for the required role.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="rounded-xl border border-white/20 bg-white/10 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-cyan-300/60"
            >
              Go Back
            </button>
            <button
              type="button"
              onClick={() =>{ localStorage.clear(); window.location.assign("/");}}
              className="rounded-xl bg-cyan-400 px-5 py-2.5 text-sm font-semibold text-slate-950 transition hover:bg-cyan-300 focus:outline-none focus:ring-2 focus:ring-cyan-300/60"
            >
              Go to Home
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}

export default NotAuthorised;
